import React, { useState } from "react";
import moment from "moment";
import { Alert } from "../../../controls";

const FuelPolicyValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  if (record.editTankerToLand && (!record.tankerToLand || record.tankerToLand <= 0)) {
    error = true;
    errorMessage = "Please enter a valid tanker quantity.";
  }   

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} />
  );
}

export default FuelPolicyValidator;
